import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { EncounterTypeEligibilityImportsService } from 'app/core/services/encounter-type-eligibility-imports.service';
import { DownloadService } from 'app/core/services/download.service';
import { EncounterTypeEligibilityImport } from 'app/core/models/encounter-type-eligibility-import.model';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';

@Component({
    selector: 'app-capture-admin-import-encounter-type-eligibilities-history',
    templateUrl: './capture-admin-import-encounter-type-eligibilities-history.component.html',
    imports: [ImportNavComponent,
              PaginationHeaderComponent,
              FaIconComponent,
              NgbDropdown,
              NgbDropdownToggle,
              NgbDropdownMenu,
              PaginationComponent,
              MatProgressSpinner,
              DecimalPipe,
              TitleCasePipe,
              DatePipe,
              BlankValueDashPipe]
})
export class CaptureAdminImportEncounterTypeEligibilitiesHistoryComponent implements OnInit, OnDestroy {
  private encounterTypeEligibilityImportsService = inject(EncounterTypeEligibilityImportsService);
  private downloadService = inject(DownloadService);

  loading = false;
  encounterTypeEligibilityImports: EncounterTypeEligibilityImport[] = [];
  nextCheckTimeout = null;
  paging: LimitOffsetPaging;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadImports(this.paging.currentPage);
  }

  ngOnDestroy() {
    clearTimeout(this.nextCheckTimeout);
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadImports(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadImports(page);
  }

  onCancelClick($event, encounterTypeEligibilityImport: EncounterTypeEligibilityImport) {
    $event.preventDefault();
    this.encounterTypeEligibilityImportsService.
      cancel(encounterTypeEligibilityImport.id).subscribe(invoiceImport => {
        const index = this.encounterTypeEligibilityImports.findIndex(imp => imp.id === invoiceImport.id);

        if (index > -1) {
          this.encounterTypeEligibilityImports[index] = invoiceImport;
          this.encounterTypeEligibilityImports = [...this.encounterTypeEligibilityImports];
        }
      });
  }

  onDownloadOriginalClick($event, encounterTypeEligibilityImport: EncounterTypeEligibilityImport) {
    $event.preventDefault();
    this.encounterTypeEligibilityImportsService.get(encounterTypeEligibilityImport.id).subscribe(invoiceImport => {
      const downloadUrl = invoiceImport.fileExpirableDownloadPath;
      this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }

  onDownloadSkippedClick($event, encounterTypeEligibilityImport: EncounterTypeEligibilityImport) {
    $event.preventDefault();
    this.encounterTypeEligibilityImportsService.get(encounterTypeEligibilityImport.id).subscribe(invoiceImport => {
      const downloadUrl = invoiceImport.skippedFileExpirableDownloadPath;
      this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }

  private loadImports(page, loading = true) {
    this.loading = loading;
    const paging = { page, pageSize: this.paging.pageSize };
    this.encounterTypeEligibilityImportsService.getList(paging).subscribe(result => {
      this.encounterTypeEligibilityImports = result.encounterTypeEligibilityImports;
      this.paging = result.meta.paging;
      this.loading = false;

      const anyActive: boolean = this.encounterTypeEligibilityImports.some(invoiceImport => invoiceImport.active);

      if (anyActive) {
        this.nextCheckTimeout = setTimeout(() => this.loadImports(this.paging.currentPage, false), 5000);
      }
    });
  }
}